import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { showErrorToast, showSuccessToast } from '../../../components/atoms/Utlis/Toast';
import { createPackageAPI, deletePackageAPI, getAccountInfoAPI, getAllPackageAPI, getAllPackageTransactions, getPackageBookingAPI, getPackageRequestAPI, sendAccountInfoAPI, sendPackageApprovePriceAPI, updatePackageAPI, updatePackagePriceStatusAPI, updateAccountInfoAPI, getCashfreeVendorStatusAPI } from '../../ApiCalls/Dashboard/PackageAPI';
import { PackageState } from '../../Slice/Dashboard/PackageSlice';
import { AccountDetailsType, Package, PackageRequest, Transaction } from '../../../Data/package.dto';
import { trackClarityEvent } from '../../../analytics/ClarityAnalytics';
import { CLARITY_EVENTS } from '../../../analytics/EventTypes';


export const PackageReducer = (builder: ActionReducerMapBuilder<PackageState>) => {
    builder.addCase(createPackageAPI.pending, (state) => {
        state.loading = true;
        state.isError = false;
        state.success = false;
        state.isPackageUpdate = false;
        state.error = {};
    })
        .addCase(createPackageAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.isPackageUpdate = true;
            showSuccessToast("Package created successfully.")
            trackClarityEvent(CLARITY_EVENTS.PACKAGE_CREATED, {
                package_id: action.payload?.id || action.payload?.package_id,
                package_title: action.payload?.title,
                package_price: action.payload?.price,
            })
            // state.Events = action.payload;
        })
        .addCase(createPackageAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(getAllPackageAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(getAllPackageAPI.fulfilled, (state, action: PayloadAction<Package[]>) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.packages = [];
            if (action.payload && action.payload.length > 0)
                state.packages = action.payload;

            state.isPackageUpdate = false;
        })
        .addCase(getAllPackageAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            state.isPackageUpdate = false;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(updatePackageAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            // console.log("called from update")
            state.error = {};
        })
        .addCase(updatePackageAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.isPackageUpdate = true;
            showSuccessToast("Package updated successfully.")
            trackClarityEvent(CLARITY_EVENTS.PACKAGE_UPDATED, {
                package_id: action.payload?.id || action.payload?.package_id,
                package_title: action.payload?.title,
                package_price: action.payload?.price,
            })
        })
        .addCase(updatePackageAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(deletePackageAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(deletePackageAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.isPackageUpdate = true;
            showSuccessToast("Package deleted successfully.")
            trackClarityEvent(CLARITY_EVENTS.PACKAGE_DELETED, {
                package_id: action.meta?.arg?.package_id || action.payload?.package_id || action.payload?.id,
            })
        })
        .addCase(deletePackageAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(getAllPackageTransactions.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(getAllPackageTransactions.fulfilled, (state, action: PayloadAction<Transaction[]>) => {
            state.loading = false;
            state.transactions = action.payload;
        })
        .addCase(getAllPackageTransactions.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(sendAccountInfoAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(sendAccountInfoAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isAccountUpdated = true;
            showSuccessToast("Account information updated.")
        })
        .addCase(sendAccountInfoAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(getAccountInfoAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(getAccountInfoAPI.fulfilled, (state, action: PayloadAction<AccountDetailsType>) => {
            state.isAccountUpdated = false;
            state.loading = false;
            state.account = action.payload;
        })
        .addCase(getAccountInfoAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            console.log(action.payload)
        })
        .addCase(getPackageRequestAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(getPackageRequestAPI.fulfilled, (state, action: PayloadAction<PackageRequest[]>) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.packageRequest = [];
            if (action.payload && action.payload.length > 0)
                state.packageRequest = action.payload;
        })
        .addCase(getPackageRequestAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(sendPackageApprovePriceAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(sendPackageApprovePriceAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            showSuccessToast("Package Price sent successfully.")
            const actionType = action.meta?.arg?.action || action.payload?.action;
            if (actionType === 'approve') {
                trackClarityEvent(CLARITY_EVENTS.PACKAGE_REQUEST_APPROVED, {
                    request_ids: action.meta?.arg?.request_ids || [],
                    price: action.meta?.arg?.price,
                })
            } else if (actionType === 'reject') {
                trackClarityEvent(CLARITY_EVENTS.PACKAGE_REQUEST_REJECTED, {
                    request_ids: action.meta?.arg?.request_ids || [],
                })
            }
        })
        .addCase(sendPackageApprovePriceAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(updatePackagePriceStatusAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(updatePackagePriceStatusAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            showSuccessToast("Package Pricing status updated successfully");
            state.isPackageUpdate = true;
        })
        .addCase(updatePackagePriceStatusAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(getPackageBookingAPI.pending, (state) => {
            state.PackageBookings.loading = true;
        })
        .addCase(getPackageBookingAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.PackageBookings.loading = false;
            state.PackageBookings.data = action.payload?.results ?? [];
            state.PackageBookings.booked_packages = action.payload?.booked_packages ?? null;
            state.PackageBookings.isUpdated = false;
        })
        .addCase(getPackageBookingAPI.rejected, (state, action: PayloadAction<any>) => {
            if (action.payload && action.payload.message) {

                showErrorToast(action.payload.message)
            } else {
                showErrorToast("Error in fetching bookings.")
                console.log(action.payload)
            }
        })
        .addCase(updateAccountInfoAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(updateAccountInfoAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isAccountUpdated = true;
            showSuccessToast("Account information updated.")
        })
        .addCase(updateAccountInfoAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(getCashfreeVendorStatusAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(getCashfreeVendorStatusAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.cashfreeVendorStatus = action.payload;
        })
        .addCase(getCashfreeVendorStatusAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                const rawMsg = action.payload.message;
                if (rawMsg.includes("No Cashfree vendor linked")) {
                    showErrorToast("Cashfree payment gateway is not onboarded. Please complete your bank details setup to accept payments.");
                } else {
                    showErrorToast(rawMsg);
                }
            } else {
                console.log(action.payload)
            }
        });
};
